// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Object {
  /**
   * WARNING: Renaming this to 'filter' or 'filterBy' will conflict with prime react datatable and treetable
   * filter logic.
   */
  filterObjBy(obj: any, predicate: any): { [k: string]: unknown; };

  /**
   * Returns an array of all property names of an object using dot notation.
   */
  properties(obj: any, predicate: any): string[];
}

(function () {
  if (!Object.hasOwnProperty.call(Object.prototype, "filterObjBy")) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Object.prototype, "filterObjBy", {
      writable: true,
      value: function (obj: any, predicate: any) {
        return Object.fromEntries(Object.entries(obj).filter(predicate));
      },
    });
  }
})();

(function () {
  function flattenObject(obj: any, prefix: string = "") {
    return Object.keys(obj).reduce((acc: any, k: string) => {
      const pre = prefix.length ? prefix + "." : ""; // Construct the prefix for the current key
      if (typeof obj[k] === "object" && obj[k] !== null && !Array.isArray(obj[k])) {
        Object.assign(acc, flattenObject(obj[k], pre + k));
      } else {
        acc.push(pre + k); // Otherwise, assign the current value to the accumulator with the constructed key
      }
      return acc; // Return the accumulator
    }, []);
  }

  if (!Object.hasOwnProperty.call(Object.prototype, "properties")) {
    // eslint-disable-next-line no-extend-native
    Object.defineProperty(Object.prototype, "properties", {
      writable: true,
      value: function (obj: any, prefix: string = "") {
        return flattenObject(obj, prefix);
      },
    });
  }
})();
